import type { Tour } from '@/config/objects/tours';
import { useOutletContext } from 'react-router-dom';

interface TourContext {
  tour: Tour | undefined;
  isLoading: boolean;
}

export function useTourContext() {
  return useOutletContext<TourContext>();
}
